import VConsole from 'vconsole';

// or init with options
new VConsole({ maxLogNumber: 1000 });
